import { Pagination } from '@/domain/entities/Pagination'

export class DropBox {
  public id?: number
  public externalId?: string
  public name?: string
  public serialNumber?: string
  public lat?: number
  public long?: number
  public address?: string
  public phoneNumber?: string
  public agentCode?: string
  public status?: string
  public visibility?: string
  public createdAt?: string
  public updatedAt?: string
  public machineStatus?: string
  public machineCondition?: string
  public printerStatus?: string
  public doorPackageInputStatus?: string
  public doorPackageOutputStatus?: string
  public scannerStatus?: string
  public availabilityStatus?: string
  public capacityPercentage?: number

  constructor(
    id?: number,
    externalId?: string,
    name?: string,
    serialNumber?: string,
    lat?: number,
    long?: number,
    address?: string,
    phoneNumber?: string,
    agentCode?: string,
    status?: string,
    visibility?: string,
    createdAt?: string,
    updatedAt?: string,
    machineStatus?: string,
    machineCondition?: string,
    printerStatus?: string,
    doorPackageInputStatus?: string,
    doorPackageOutputStatus?: string,
    scannerStatus?: string,
    availabilityStatus?: string,
    capacityPercentage?: number
  ) {
    this.id = id
    this.externalId = externalId
    this.name = name
    this.serialNumber = serialNumber
    this.lat = lat
    this.long = long
    this.address = address
    this.phoneNumber = phoneNumber
    this.agentCode = agentCode
    this.status = status
    this.visibility = visibility
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.machineStatus = machineStatus
    this.machineCondition = machineCondition
    this.printerStatus = printerStatus
    this.doorPackageInputStatus = doorPackageInputStatus
    this.doorPackageOutputStatus = doorPackageOutputStatus
    this.scannerStatus = scannerStatus
    this.availabilityStatus = availabilityStatus
    this.capacityPercentage = capacityPercentage
  }
}

export interface DropBoxMonitoringSummary {
  online: number
  onlineWithIssues: number
  offline: number
}

export class DropBoxes {
  public pagination?: Pagination
  public data?: DropBox[]
  public summary?: DropBoxMonitoringSummary

  constructor(
    pagination?: Pagination,
    data?: DropBox[],
    summary?: DropBoxMonitoringSummary
  ) {
    this.pagination = pagination
    this.data = data
    this.summary = summary
  }
}
